import React, { useEffect, useState } from 'react'
import Header from '../Header/Header.js'
import SideBar from './SideBar.js'
import SettingsHeader from './SettingsHeader.js'
import { RiUserSettingsFill } from 'react-icons/ri'
import { GiSettingsKnobs } from 'react-icons/gi'
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import SpinLoader from '../components/SpinLoader.js'
import { UPDATE_USER_DETAILS } from '../graphql/Mutation/Signin.js'
import { GET_ROLE_USER } from '../graphql/Query/Signin.js'
import { useMutation, useQuery } from '@apollo/client'
import { toast } from 'react-toastify'
import { useFileUpload } from '../Common/PreSignUrl.jsx'
import { IMAGE_URL } from '../config.js'


const Settings = () => {
    const { handleFileUpload } = useFileUpload();
    const [updateUserDetails, { loading }] = useMutation(UPDATE_USER_DETAILS);
    const { data, refetch } = useQuery(GET_ROLE_USER, {
        fetchPolicy: "cache-and-network"
    })
    const formik = useFormik({
        initialValues: {
            firstName: "",
            lastName: "",
            mobileNumber: "",
            documentType: "",
            documentType: "",
            documentId: "",
            // documentName: "",
            frontImage: "",
            backImage: "",
        },
        validationSchema: Yup.object({
            // firstName: Yup.string().required("First name is required"),
            // lastName: Yup.string().required("Last name is required"),
            mobileNumber: Yup.string().matches(/^\d{10}$/, "Invalid mobile number").required("Mobile number is required"),
            // documentType: Yup.string().required("KYC type is required"),
            documentType: Yup.string().required("Document type is required"),
            documentId: Yup.string().required("Document ID is required"),
            frontImage: Yup.string().required("Front Image is required"),
            backImage: Yup.string().required("Back Image is required"),
            // documentName: Yup.string().required("Name on document is required"),
        }),
        onSubmit: async (values, { resetForm }) => {
            // console.log('✌️values --->', values);
            try {
                const data = await updateUserDetails({
                    variables: {
                        input: {
                            firstName: values?.firstName,
                            lastName: values?.lastName,
                            documentType: values?.documentType,
                            documentId: values?.documentId,
                            documentFrontImage: values?.frontImage,
                            documentBackImage: values?.backImage,
                            mobile: values?.mobileNumber,
                        },
                    },
                });
                if (data?.data?.updateUser?.success) {
                    toast.success(data?.data?.updateUser?.message);
                    refetch()
                    resetForm();
                }
            } catch (err) {
                toast.error(err.message);
            }
        },
    });
    useEffect(() => {
        if (data?.me) {
            const userData = data?.me;
            formik.setValues({
                firstName: userData?.firstName || "",
                lastName: userData?.lastName || "",
                mobileNumber: userData?.mobile || "",
                documentType: userData?.documentType || "",
                documentId: userData?.documentId || "",
                frontImage: userData?.documentFrontImage || "",
                backImage: userData?.documentFrontImage || "",
            });
        }
    }, [data]);

    const documentOptions = [
        { value: "", label: "Select Document Type", isDisabled: true },
        { value: "Aadhar Card", label: "Aadhar Card" },
        { value: "Driving License", label: "Driving License" },
        { value: "Passport", label: "Passport" },
        { value: "Voter ID", label: "Voter ID" },
        { value: "Pan Card", label: "Pan Card" },
    ];


    const [isLoading, setIsLoading] = useState(false);


    const handleFileChange = (event, keyPrefix, folderName) => {
        if ((!event?.target?.files || !event?.currentTarget?.files) || event?.target?.files?.length === 0) {
            setIsLoading(false);
            // console.log("===");
        }
        handleFileUpload({
            event,
            keyPrefix,
            setStateCallback: (url) => {
                const newUrl = url.split('/').slice(-2).join('/');
                // console.log('✌️newUrl --->', newUrl);
                if (keyPrefix === "front") {
                    formik.setFieldValue("frontImage", newUrl);
                }
                if (keyPrefix === "back") {
                    formik.setFieldValue("backImage", newUrl);
                }
                setIsLoading(false);
            },
            setIsLoading,
            folderName
        });
    }
    return (
        <>
            {/* Header */}
            <Header />

            <div className="flex min-h-screen bg-slate-100 overflow-hidden">
                {/* Sidebar */}

                <SideBar />

                {/* Main Content */}
                <div className="flex-1 space-y-6 px-0 py-6 md:p-6 overflow-x-hidden ml-16">
                    <SettingsHeader data={data?.me?.SellerId} />

                    <div className="grid grid-cols-12 md:space-x-7 min-h-screen">
                        {/* Sidebar (Left Panel) */}
                        <div className="col-span-3 bg-white p-6 rounded-md hidden md:block">
                            {/* Content for sidebar */}
                            <h1 className='font-semibold text-xl mb-6'>Settings</h1>
                            <p>Take your shipping experience a notch higher with us by regulating your panel settings as per your convenience and specific business requirements. From importing orders to managing labels and all other account settings, get everything at the tap of your finger for an uninterrupted experience.</p>
                            <GiSettingsKnobs className="h-96 w-96 text-slate-100" />
                        </div>

                        {/* Main Content (Right Panel) */}
                        <div className="col-span-12 md:col-span-9 rounded-md bg-white p-6">
                            {/* Main content goes here */}
                            {/* <div className="max-w-2xl mx-auto p-6 bg-white shadow-lg rounded-lg"> */}
                            <p className="px-4 py-2 mb-7 border border-sky-100 bg-sky-50">KYC Verification Form</p>
                            <form onSubmit={formik.handleSubmit} className="grid gap-7 text-sm">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block font-medium mb-2">First Name <span className='text-slate-400 font-normal'>(Optional)</span></label>
                                        <input
                                            type="text"
                                            name="firstName"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.firstName}
                                            disabled={data?.me?.firstName}
                                            placeholder='Enter First Name'
                                            className="w-full p-2 border-b border-dashed border-gray-300 focus:outline-none"
                                        />
                                    </div>
                                    <div>
                                        <label className="block font-medium mb-2">Last Name <span className='text-slate-400 font-normal'>(Optional)</span></label>
                                        <input
                                            type="text"
                                            name="lastName"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.lastName}
                                            disabled={data?.me?.lastName}
                                            placeholder='Enter Last Name'
                                            className="w-full p-2 border-b border-dashed border-gray-300 focus:outline-none"
                                        />
                                    </div>
                                </div>
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block font-medium mb-2">Email <span className="text-red-400">*</span></label>
                                        <input
                                            type="email"
                                            name="email"
                                            disabled
                                            value={data?.me?.email}
                                            placeholder='Enter Mail'
                                            className="w-full p-2 border-b border-dashed border-gray-300 focus:outline-none"
                                        />
                                    </div>

                                    <div>
                                        <label className="block font-medium mb-2">Mobile Number <span className="text-red-400">*</span></label>
                                        <input
                                            type="text"
                                            name="mobileNumber"
                                            onChange={formik.handleChange}
                                            disabled={data?.me?.mobile} onBlur={formik.handleBlur}
                                            value={formik.values.mobileNumber}
                                            placeholder='Enter Mobile No.'
                                            className="w-full p-2 border-b border-dashed border-gray-300 focus:outline-none"
                                        />
                                        {formik.touched.mobileNumber && formik.errors.mobileNumber && (
                                            <p className="text-red-500 text-xs mt-1">{formik.errors.mobileNumber}</p>
                                        )}
                                    </div>
                                </div>

                                <div className="mb-4">
                                    <label className="block text-sm font-medium mb-2 text-gray-700">
                                        Document Type <span className="text-red-500">*</span>
                                    </label>
                                    <Select
                                        options={documentOptions}
                                        name="documentType"
                                        isDisabled={data?.me?.documentType}
                                        value={documentOptions.find((opt) => opt.value === formik.values.documentType)}
                                        onChange={(selectedOption) => formik.setFieldValue("documentType", selectedOption.value)}
                                        onBlur={() => formik.setFieldTouched("documentType", true)}
                                        className="text-sm"
                                        classNamePrefix="react-select"
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                borderColor: state.isFocused ? '#d1d5db' : '#d1d5db',
                                                '&:hover': { borderColor: '#64748B' },
                                                boxShadow: state.isFocused ? '0 0 0 0px #000000' : 'none',
                                                borderRadius: '0.375rem',
                                            }),
                                            singleValue: (base) => ({
                                                ...base,
                                                color: '#000000',
                                                fontSize: '0.875rem',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                backgroundColor: state.isSelected ? '#cbd5e1' : state.isFocused ? '#cbd5e1' : 'white',
                                                color: state.isSelected ? '#000000' : '#000000',
                                                fontSize: '0.875rem',
                                                '&:hover': {
                                                    backgroundColor: '#cbd5e1',
                                                    color: '#000000',
                                                    fontSize: '0.875rem',
                                                }
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '14px',
                                                color: '#A3AAB5',
                                                fontSize: '0.875rem',
                                            }),
                                        }}
                                    />
                                    {formik.touched.documentType && formik.errors.documentType && (
                                        <p className="text-red-500 text-xs mt-1">{formik.errors.documentType}</p>
                                    )}
                                </div>


                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <label className="block font-medium mb-2">Document ID <span className="text-red-400">*</span></label>
                                        <input
                                            type="text"
                                            name="documentId"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.documentId}
                                            disabled={data?.me?.documentId}
                                            placeholder='Enter Document ID No.'
                                            className="w-full p-2 border-b border-dashed border-gray-300 focus:outline-none"
                                        />
                                        {formik.touched.documentId && formik.errors.documentId && (
                                            <p className="text-red-500 text-xs mt-1">{formik.errors.documentId}</p>
                                        )}
                                    </div>
                                </div>

                                <div className="space-y-4">
                                    {/* File Upload Grid */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div className="flex flex-col">
                                            <label className="block text-sm mb-2 font-medium text-gray-700">
                                                Upload Document Front Image/PDF <span className="text-red-500">*</span>
                                            </label>
                                            <div className="w-full flex flex-col items-center justify-center p-4 border-2 border-dashed border-gray-300 rounded-lg bg-gray-50 hover:border-slate-700 transition duration-300 ease-in-out cursor-pointer">
                                                <label className="flex flex-col items-center justify-center w-full cursor-pointer">
                                                    <span className="text-gray-600 font-medium text-sm mb-2">Upload Document Front Image/PDF <span className="text-red-500">*</span></span>
                                                    <div className="flex items-center space-x-2 bg-slate-700 text-white px-4 py-2 rounded-md shadow-md hover:bg-slate-800 transition">
                                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 16v-4m0 0V8m0 4H8m4 0h4M12 2a10 10 0 100 20 10 10 0 000-20z"></path>
                                                        </svg>
                                                        <span className="text-sm font-semibold">Choose File</span>
                                                    </div>
                                                    <input
                                                        type="file"
                                                        name="frontImage"
                                                        accept="image/*,application/pdf"
                                                        onChange={(e) => handleFileChange(e, "front", "userDetails")}
                                                        className="hidden"
                                                        disabled={data?.me?.documentFrontImage}
                                                    />
                                                    {formik.touched.frontImage && formik.errors.frontImage && (
                                                        <p className="text-red-500 text-xs mt-1">{formik.errors.frontImage}</p>
                                                    )}
                                                </label>
                                            </div>


                                        </div>
                                        <div className="flex flex-col">
                                            <label className="block text-sm font-medium mb-2 text-gray-700">
                                                Upload Document Back Image/PDF <span className="text-red-500">*</span>
                                            </label>
                                            <div className="w-full flex flex-col items-center justify-center p-4 border-2 border-dashed border-gray-300 rounded-lg bg-gray-50 hover:border-slate-700 transition duration-300 ease-in-out cursor-pointer">
                                                <label className="flex flex-col items-center justify-center w-full cursor-pointer">
                                                    <span className="text-gray-600 font-medium text-sm mb-2">
                                                        Upload Document Back Image/PDF <span className="text-red-500">*</span>
                                                    </span>
                                                    <div className="flex items-center space-x-2 bg-slate-700 text-white px-4 py-2 rounded-md shadow-md hover:bg-slate-800 transition">
                                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 16v-4m0 0V8m0 4H8m4 0h4M12 2a10 10 0 100 20 10 10 0 000-20z"></path>
                                                        </svg>
                                                        <span className="text-sm font-semibold">Choose File</span>
                                                    </div>
                                                    <input
                                                        type="file"
                                                        name="backImage"
                                                        accept="image/*,application/pdf"
                                                        onChange={(e) => handleFileChange(e, "back", "userDetails")}
                                                        className="hidden"
                                                        disabled={data?.me?.documentBackImage}
                                                    />
                                                    {formik.touched.backImage && formik.errors.backImage && (
                                                        <p className="text-red-500 text-xs mt-1">{formik.errors.backImage}</p>
                                                    )}
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Image & PDF Previews */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        {formik.values.frontImage && (
                                            <div className="relative w-full h-40 border rounded-lg overflow-hidden shadow-sm">
                                                <img src={`${IMAGE_URL}/${formik.values.frontImage}`} alt="Front Preview" className="object-cover w-full h-full" />
                                            </div>
                                        )}
                                        {formik.values.backImage && (
                                            <div className="relative w-full h-40 border rounded-lg overflow-hidden shadow-sm">
                                                <img src={`${IMAGE_URL}/${formik.values.backImage}`} alt="Back Preview" className="object-cover w-full h-full" />
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <button type="submit" disabled={data?.me?.documentBackImage && data?.me?.documentType} className="bg-slate-800 text-white p-2 rounded hover:bg-slate-900 cursor-pointer">Submit {loading && <SpinLoader className="text-sm ms-3" />} </button>
                            </form>
                            {/* </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Settings
